import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';


type ContentLoadErrorBlockInternalProps = {
  icon?: IconProps;
  message?: TextProps;
  title?: TextProps;
};

type ContentLoadErrorBlockPropsValues = {
  '': ContentLoadErrorBlockInternalProps;
};

const propValues: ContentLoadErrorBlockPropsValues = {
  '': {
    icon: {
      asset: 'WarningOutline',
      style: 'DigitalGrey60',
    },
    message: {
      type: 'Subheading',
      size: 'Large',
      style: 'Light',
      colour: 'SubduedDark',
      align: 'Center',
    },
    title: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Center',
    },
  },
};

const getProps = (type: string): ContentLoadErrorBlockInternalProps => {
  const values: ContentLoadErrorBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
